'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = undefined;

var _reduxTap = require('redux-tap');

var _reduxTap2 = _interopRequireDefault(_reduxTap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var REDUCER_KEY = '@@redux-hotjar-state';
var QUEUE_TAGS = '@@REDUX_HOTJAR_QUEUE_TAGS';
var FLUSH_QUEUE = '@@REDUX_HOTJAR_FLUSH_QUEUE';

var reducer = exports.reducer = function reducer() {
  return _defineProperty({}, REDUCER_KEY, function () {
    var state = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
    var _ref = arguments[1];
    var type = _ref.type;
    var payload = _ref.payload;

    switch (type) {
      case QUEUE_TAGS:
        {
          return [].concat(_toConsumableArray(state), [payload]);
        }

      case FLUSH_QUEUE:
        {
          return [];
        }

      default:
        {
          return state;
        }
    }
  });
};

var isAllStrings = function isAllStrings(vals) {
  return vals.every(function (val) {
    return typeof val === 'string';
  });
};

var typeError = function typeError(tag) {
  console.error('Hotjar tags must be strings or arrays of strings', tag);
};

var selectMeta = function selectMeta(_ref3) {
  var meta = _ref3.meta;
  return meta && meta.hotjar;
};

exports.default = function () {
  return (0, _reduxTap2.default)(selectMeta, function (input, action, store) {
    if (typeof input !== 'string' && !Array.isArray(input)) {
      typeError(input);
      return;
    }

    var tags = [].concat(input);

    if (tags.length === 0) {
      return;
    }

    if (!isAllStrings(tags)) {
      typeError(tags);
      return;
    }

    var getState = store.getState;
    var dispatch = store.dispatch;

    var isUniversal = getState()[REDUCER_KEY];

    isUniversal && dispatch({ type: QUEUE_TAGS, payload: tags });

    if (typeof window !== 'undefined' && typeof window.hj === 'function') {
      (isUniversal ? getState()[REDUCER_KEY] : [tags]).forEach(function (queuedTags) {
        return window.hj('tagRecording', queuedTags);
      });

      isUniversal && dispatch({ type: FLUSH_QUEUE });
    }
  });
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-hotjar/lib/index.js
 ** module id = 362
 ** module chunks = 0
 **/